// extracted by mini-css-extract-plugin
export default {"invalidDataError":"UserProfile_invalidDataError__e0miy"};